var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data[_vm.status])?_c('a-tag',{attrs:{"color":_vm.data[_vm.status].color}},[_vm._v("\n  "+_vm._s(_vm.data[_vm.status].text)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }